import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

const faqs = [
  {
    question: "রিউনিয়ন অনুষ্ঠান কবে অনুষ্ঠিত হতে যাচ্ছে?",
    answer:
      "কোনো ধরনের প্রতিকূল পরিস্থিতি সৃষ্টি না হলে ইনশাআল্লাহ ঈদুল ফিতরের তৃতীয় দিন, অর্থাৎ ২০ অথবা ২১ মার্চ ২০২৬ তারিখে রিউনিয়ন অনুষ্ঠান আয়োজন করা হবে।",
  },
  {
    question: "কারা এই রিউনিয়নে অংশগ্রহণের সুযোগ পাবেন?",
    answer:
      "২০২৫ সাল পর্যন্ত সকল প্রাক্তন পিজিয়ান শিক্ষার্থী সম্মানিত অতিথি হিসেবে এই রিউনিয়নে অংশগ্রহণ করতে পারবেন।",
  },
  {
    question: "রিউনিয়নে অংশগ্রহণের জন্য রেজিস্ট্রেশন কি বাধ্যতামূলক?",
    answer:
      "হ্যাঁ, রেজিস্ট্রেশন সম্পন্ন করা ব্যতীত কোনোভাবেই রিউনিয়নে অংশগ্রহণের অনুমতি প্রদান করা হবে না।",
  },
  {
    question: "রেজিস্ট্রেশনের নির্ধারিত ফি কত টাকা?",
    answer:
      "রিউনিয়নে অংশগ্রহণের জন্য জনপ্রতি রেজিস্ট্রেশন ফি নির্ধারণ করা হয়েছে মাত্র ১০০০ টাকা।",
  },
  {
    question: "রেজিস্ট্রেশনের মাধ্যমে কাদের সঙ্গে আনা যাবে?",
    answer:
      "প্রত্যেক রেজিস্ট্রারকৃত অংশগ্রহণকারী শুধুমাত্র স্বামী অথবা স্ত্রীকে সঙ্গে আনতে পারবেন, যার জন্য পৃথকভাবে রেজিস্ট্রেশন আবশ্যক।",
  },
  {
    question: "রেজিস্ট্রেশন সফল হয়েছে কিনা তা কীভাবে নিশ্চিত করবেন?",
    answer:
      "রেজিস্ট্রেশন সফলভাবে সম্পন্ন হলে এক ঘণ্টার মধ্যে এসএমএস পাঠানো হবে। সমস্যা হলে জরুরি নম্বরে যোগাযোগ করুন।",
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section className=" bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950 py-20 px-4">
      <div className="max-w-4xl mx-auto">

        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
            রিউনিয়ন সম্পর্কিত গুরুত্বপূর্ণ প্রশ্ন ও উত্তর
          </h1>
          <p className="text-blue-200 max-w-2xl mx-auto text-base md:text-lg">
            অনুষ্ঠান সম্পর্কে বিস্তারিত জানতে নিচের তথ্যগুলো দেখুন
          </p>
        </div>

        {/* FAQ Cards */}
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-lg border border-white/20
              rounded-2xl overflow-hidden shadow-xl transition-all duration-300"
            >
              <button
                onClick={() =>
                  setActiveIndex(activeIndex === index ? null : index)
                }
                className="w-full flex justify-between items-center p-5 md:p-6 text-left"
              >
                <h3 className="text-white font-semibold text-base md:text-xl pr-4">
                  {faq.question}
                </h3>

                <span
                  className={`min-w-[38px] min-h-[38px] flex items-center justify-center rounded-full
                  bg-gradient-to-br from-blue-500 to-indigo-600 text-white
                  transition-transform duration-300
                  ${activeIndex === index ? "rotate-180" : ""}`}
                >
                  <IoIosArrowDown />
                </span>
              </button>

              <div
                className={`px-5 md:px-6 transition-all duration-300 overflow-hidden
                ${activeIndex === index ? "max-h-96 pb-6 opacity-100" : "max-h-0 opacity-0"}`}
              >
                <p className="text-blue-100 leading-relaxed text-sm md:text-base">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
